import { qq } from "bobjoll/ts/library/gr/dom.q";
import Countdown from "../partials/countdown";

const countdownElements = qq('.countdown');

countdownElements.forEach(countdown => {
    const dateStart = countdown.dataset.dateStart;
    const dateEnd = countdown.dataset.dateEnd;

    if (dateStart && dateEnd) {
        new Countdown({
            container: countdown,
            dateEnd: new Date(dateEnd),
            language: {
                Days: countdown.dataset.dateDays || 'Days',
                Hours: countdown.dataset.dateHours || 'Hours',
                Minutes: countdown.dataset.dateMinutes || 'Minutes',
                Seconds: countdown.dataset.dateSeconds || 'Seconds',
            }
        })
    }
});